import React from "react";

import GradientBorder from "examples/GradientBorder";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import borders from "assets/theme/base/borders";

import { dataSuport } from "./benefitsData";

const MrCryptoSuport = () => {
  return (
    <GradientBorder borderRadius={borders.borderRadius.form} minWidth="100%" maxWidth="100%">
        <VuiBox borderRadius="inherit"
          p="20px"
          sx={({ palette: { secondary } }) => ({
            backgroundColor: secondary.focus,
          })}>
          <VuiTypography color="light" variant="h3" fontWeight="bold" mb="18px">
            Mr.Crypto Suport
          </VuiTypography>
          <VuiTypography color="light" variant="h6" fontWeight="regular" mb="15px">
            Pe lângă ajutorul oferit prin resursele gratis pe care le avem puse deja la dispoziția oricui și anume: Canalul de youtube Mr.Crypto, grupul de resurse Mr.Crypto Academy și grupul de chat Mr.Crypto Community cei din grupul Mr.Crypto Suport vor beneficia de următoarele avantaje.
          </VuiTypography>
          {dataSuport.map((point, index) => (
            <VuiTypography color="light" variant="button" fontWeight="regular" key={index}>
              🔥 {index + 1}. {point}
              <br></br>
            </VuiTypography>
          ))}
          <VuiTypography color="light" variant="button" fontWeight="regular" mt="15px">
            ✅ Suportul o sa fie acordat de către cei 3 fondatori: mr.crypto, cristispd și romulusiobaj și adminii: cr1pt0_d3v, playmak3r.   
          </VuiTypography>
          <br></br> 
          <VuiTypography color="light" variant="button" fontWeight="regular" mb="15px">
            ✅ Dacă, consideri că ajutorul oferit prin mijloacele de până acum ți-a fost de mare folos, consideră un upgrade la cunoștințele tale și o apreciere din partea ta la tot ce facem noi aici, în mod voluntar.
          </VuiTypography>
          <br></br>
          <VuiTypography color="light" variant="button" fontWeight="regular" mb="15px">
            💵 Preț unui abonament este de 100$ (BUSD/USDT/USDC) pe lună. Din data de 1 până în ultima zi din lună. Din 1 decembrie până în 31 decembrie chiar dacă te-ai înscris pe data de 15. 
          </VuiTypography>
        </VuiBox>
    </GradientBorder>
  );
};

export default MrCryptoSuport;
